import React, { useState, useEffect, useContext } from "react";
import moment from "moment";

//import "./input-range.css";
import AnalyserContext from "./analyserContext";
import useTimeline from "../UserTimeline/useTimeline";
import TooltipSlider from "./TooltipSlider";

export default function TimeRangeSelector() {
  const { timeline } = useTimeline();
  const timePoints =
    timeline?.events
      ?.sort((event1, event2) => event1.time - event2.time)
      .map((event) => event.time) ?? []; // array of timeStamps, extracted from timeline
  const { moodboard, moodboardDispatch } = useContext(AnalyserContext);

  const [value, setValue] = useState([0, 0]);

  const handleRange = (index) => {
    setValue(index);
  };

  const handleAfterRange = (value) => {
    moodboardDispatch({
      type: "CHANGE_SLIDER",
      payload: {
        timeRange: [timePoints[value[0]], timePoints[value[1]]],
        update: value[1] === timePoints.length - 1,
      },
    });
  };

  useEffect(() => {
    if (timePoints.length > 0) {
      const closest = (goal) =>
        timePoints.reduce(function (prev, curr) {
          return Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev;
        });
      const min = timePoints.indexOf(closest(moodboard.timeRange[0]));
      const max = moodboard.update
        ? timePoints.length - 1
        : timePoints.indexOf(closest(moodboard.timeRange[1]));
      if (min > -1 && max > -1) {
        handleRange([min, max]);
      }
    }
  }, [moodboard]);
  return (
    <div style={{ padding: 16, width: "100%" }}>
      <TooltipSlider
        range
        draggableTrack
        value={value}
        min={0}
        max={timePoints.length - 1 >= 0 ? timePoints.length - 1 : 0}
        onChange={handleRange}
        onAfterChange={handleAfterRange}
        step={1}
        tipFormatter={(value) =>
          `${moment.utc(timePoints[value]).format("DD/MM HH:mm")}`
        }
      />
    </div>
  );
}
